import { render, staticRenderFns } from "./empty-data.vue?vue&type=template&id=6ebc6ac5&scoped=true"
import script from "./empty-data.vue?vue&type=script&lang=js"
export * from "./empty-data.vue?vue&type=script&lang=js"
import style0 from "./empty-data.vue?vue&type=style&index=0&id=6ebc6ac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebc6ac5",
  null
  
)

export default component.exports